import 'vue2-datepicker/index.css';
import 'vue2-datepicker/locale/es';

export default {
    name: 'YuriDatePicker',
    props: {
        type: {
            type: String
        },
        YuriPlaceholder: {
            type: String,
            default: 'DD/MM/AAAA'
        },
        isDisabled: {
            type: Boolean
        },
        startDate: {
            type: Object
        },
        dateSelected: {
            type: String
        },
        dateValue: {
            type: String
        },
        mustBeAdult: {
            type: Boolean,
            default: false
        },
        todayDisabled: {
            type: Boolean,
            default: false
        },
        maxDate: {
            type: Number
        }
    },
    data() {
        return {
            // Campos de opciones/configuración
            date: ''
        };
    },
    watch: {
        isDisabled: function (newValue) {
            if (newValue) {
                this.date = '';
            }
        },
        dateSelected: function (newValue) {
            if (!newValue) {
                this.date = '';
            }
        }
    },

    created() {
        if (this.dateValue) this.date = this.dateValue;

        if (this.dateSelected) {
            this.date = this.dateSelected;
        }
    },

    computed: {
        dateMinAge() {
            const minYears = this.mustBeAdult ? 18 : 0; // edad mínima en años
            const now = new Date();
            const today = this.todayDisabled
                ? new Date(now.getFullYear(), now.getMonth(), now.getDate() + 1)
                : new Date(now.getFullYear(), now.getMonth(), now.getDate());
            const minAge = new Date(today);
            minAge.setFullYear(minAge.getFullYear() - minYears);
            return minAge;
        },
        dateMaxAge() {
            const maxYears = 100; // 100 años como edad máxima
            const now = new Date();
            const today = new Date(now.getFullYear(), now.getMonth(), now.getDate());
            this.today = today;
            const maxAge = new Date(today);
            maxAge.setFullYear(maxAge.getFullYear() - maxYears);
            return maxAge;
        }
    }
};
